import React, { Component } from 'react';
import { FILE_URL,path } from './Constant';

export default class Welcome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            villa: props.villa,
            static_text:props.static_text
        }
    }

    componentDidMount = () => {
        // console.log(this.state.data);
        // console.log(this.state.villa);
    }

    _featureList = () => {
        if (this.props.data.features != null && this.props.data.features.length > 0) {
            return (
                this.props.data.features.map((item, index) => {
                    return (
                        <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3 col-6">
                            <div className="welcome-content">
                                <img src={FILE_URL+'villas/'+item.image} className="img-fluid d-block" alt={item.legend} /> <span>{item.legend} </span>
                            </div>
                        </div>
                    )
                })
            )
        }
    }

    render() {
        return (
            <div id="welcome-area">
                <div className="row">
                    <div className="col-md-12">
                        <h1>{this.props.static_text.welcome_to} { /**this.props.data.villa_type **/} {(this.props.villa.name.includes('/')?this.props.villa.name.split('/')[1]:this.props.villa.name)}</h1>
                        {/* <h6>{this.props.data.villa_type} {this.props.villa.name}, {this.props.data.region}, {this.props.data.district}, {this.props.data.country}</h6> */}
                        <h6>{this.props.data.address}</h6>
                        <div className="row py-4">
                            <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3 col-6">
                                <div className="welcome-content">
                                    <img src={path+"images/icon7.png"} className="img-fluid d-block" alt="Villa" /> <span>{this.props.data.villa_type}</span>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3 col-6">
                                <div className="welcome-content">
                                    <img src={path+"images/icon8.png"} className="img-fluid d-block" alt="6 Guests" /> <span>{this.props.data.guest} {(this.props.data.guest>1)?this.props.static_text.guests_text:this.props.static_text.guest_text}</span>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3 col-6">
                                <div className="welcome-content">
                                    <img src={path+"images/icon9.png"} className="img-fluid d-block" alt="3 Bedrooms" /> <span>{this.props.data.bedroom} {this.props.data.bedroom>1?this.props.static_text.bedroom_text+'s':this.props.static_text.bedroom_text}</span>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3 col-6">
                                <div className="welcome-content">
                                    <img src={path+"images/icon10.png"} className="img-fluid d-block" alt="3 Bathrooms" /> <span>{this.props.data.bathroom} {this.props.data.bathroom>1?this.props.static_text.bathroom_text+'s':this.props.static_text.bathroom_text}</span>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3 col-6">
                                <div className="welcome-content">
                                    <img src={path+"images/icon11.png"} className="img-fluid d-block" alt="High Luxury" /> <span>{this.props.data.luxury_level}</span>
                                </div>
                            </div>
                            {this._featureList()}
                            {/* <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3 col-6">
                                <div className="welcome-content">
                                    <img src={path+"images/icon7.png" className="img-fluid d-block" alt="Villa" /> <span>Villa</span>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3 col-6">
                                <div className="welcome-content">
                                    <img src={path+"images/icon8.png" className="img-fluid d-block" alt="6 Guests" /> <span>6 Guests</span>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3 col-6">
                                <div className="welcome-content">
                                    <img src={path+"images/icon9.png" className="img-fluid d-block" alt="3 Bedrooms" /> <span>3 Bedrooms</span>
                                </div>
                            </div> */}
                        </div>
                        <div className="row">
                            <div className="col-md-12" id="moment-at-the-property">
                                <h4>{this.props.static_text.moment_at_the_property_text}</h4>
                                <p>{this.props.data.moment_text}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <table className="table" id="exterior-interior">
                                    <thead>
                                        <tr>
                                            <th>{this.props.static_text.interior_text}</th>
                                            <th>{this.props.static_text.exterior_text}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <ul>
                                                    {this.props.data.interior != null && this.props.data.interior.length > 0
                                                        ? this.props.data.interior.map((value, index) => {
                                                            return (
                                                                <li key={"int-" + index}>{value}</li>
                                                            )
                                                        })
                                                        :
                                                        ''
                                                    }
                                                </ul>
                                            </td>
                                            <td>
                                                <ul>
                                                    {this.props.data.exterior != null && this.props.data.exterior.length > 0
                                                        ? this.props.data.exterior.map((value, index) => {
                                                            return (
                                                                <li key={"ext-" + index}>{value}</li>
                                                            )
                                                        })
                                                        :
                                                        ''
                                                    }
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
